import { useLocation, useNavigate } from 'react-router-dom'

export default function useCustomNavigate() {
    const navigate = useNavigate()
    const { pathname } = useLocation()
    

    const routeGroup = {
        "1": pathname.startsWith("/admin/registrasi-b3") || pathname.startsWith("/registrasi-b3"),
        "2": pathname.startsWith("/admin/rekomendasi-b3") || pathname.startsWith("/rekomendasi-b3"),
        "3": pathname.startsWith("/admin/pelaporan") || pathname.startsWith("/pelaporan"),
        "4": pathname.startsWith("/admin/notifikasi"),
        "5": pathname.startsWith("/admin/utama"),
        "6": pathname.startsWith('/admin/cms'),
        "7": pathname.startsWith("/admin/gudang/stok-b3") || pathname.startsWith("/gudang/stok-b3"),
        "8": pathname.startsWith("/admin/merkuri"),
        "9": pathname.startsWith("/admin/user-management"),
    };

    const getCurrentRouteGroup = () => Object.keys(routeGroup).filter(key => routeGroup[key])
    
    const getRegistrationDetailPath = (id) => navigate(`/admin/registrasi-b3/daftar/${id}`);

    const getRecomendationDetailPath = (id) => navigate(`/admin/rekomendasi-b3/daftar/${id}`);

    const getNotificationDetailPath = (id) => navigate(`/admin/notifikasi/daftar/${id}`);
    const getNotificationImportVerificationDraftPath = (notificationId) => navigate(`/admin/notifikasi/draft-surat-kebenaran-impor/${notificationId}`);
    const getNotificationImportApprovalDraftPath = (notificationId) => navigate(`/admin/notifikasi/draft-surat-persetujuan-impor/${notificationId}`);
    const getNotificationImportEcDraftPath = (notificationId) => navigate(`/admin/notifikasi/draft-surat-explicit-consent/${notificationId}`);

    const getAdminStorageDetailPath = (id) => navigate(`/admin/pelaporan/penyimpanan-b3/daftar/${id}`);
    const getCompanyStorageDetailPath = (id) => navigate(`/pelaporan/penyimpanan-b3/daftar/${id}`);
    
    const getReportTransportVehicleDetail = (id) => navigate(`/pelaporan/pengangkutan-b3/kendaraan/daftar/${id}`) 
    const getAdminReportTransportVehicleDetail = (periodeId) => navigate(`/admin/pelaporan/pengangkutan-b3/daftar/${periodeId}`) // cek lg
    const createReportTransportVehicle = (detailId) => navigate(`/pelaporan/pengangkutan-b3/kendaraan/tambah/${detailId}`)
    const editReportTransportVehicle = (detailId, id) => navigate(`/pelaporan/pengangkutan-b3/kendaraan/ubah/${detailId}/${id}`)

    const editReportDistribution = (id) => navigate(`/pelaporan/bahan-b3/distribusi/ubah/${id}`)
    
    const editReportConsumption = (id) => navigate(`/pelaporan/bahan-b3/konsumsi/ubah/${id}`)
    

    const editReportPurchase = (id) => navigate(`/pelaporan/bahan-b3/pembelian/ubah/${id}`)

    const reviewPelaporanPengelolaan = (companyId, periodId) => navigate(`/pelaporan/bahan-b3/review/pengelolaan/${companyId}/${periodId}`)

    const reviewPelaporanPengangkutan = (companyId, periodId) => navigate(`/pelaporan/bahan-b3/review/pengangkutan/${companyId}/${periodId}`)

    return {
        getRegistrationDetailPath,
        getRecomendationDetailPath,

        getNotificationDetailPath,
        getNotificationImportVerificationDraftPath,
        getNotificationImportApprovalDraftPath,
        getNotificationImportEcDraftPath,

        getAdminStorageDetailPath,
        getCompanyStorageDetailPath,

        getReportTransportVehicleDetail,
        getAdminReportTransportVehicleDetail,
        createReportTransportVehicle,
        editReportTransportVehicle,

        editReportDistribution,
        editReportConsumption,
        editReportPurchase,

        getCurrentRouteGroup,
        
        reviewPelaporanPengelolaan,
        reviewPelaporanPengangkutan
    };
}
